/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useState, useEffect, useRef } from 'react';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import './AgentSeriesFare.scss';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppLink from '../../../shared/components/app-link/AppLink';
import AddCoupon from './AddCoupon';
import AgentSeriesFare from './AgentSeriesFare';
import { getAgentCouponApi } from '../../../api/profileApi';
import AppLoading from '../../../shared/components/app-loading/AppLoading';

function AgentSeriesFarePage() {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('view-coupon');
  const [isLoading, setIsLoading] = useState(false);

  const handlegetAllCoupons = async () => {
    setIsLoading(true);
    try {
      const allCouponsRes = await getAgentCouponApi();
      if (allCouponsRes?.Root?.Status === 'OK') {
        const { CouponMaster } = allCouponsRes.Root?.Result;
        if (
          CouponMaster !== '' &&
          CouponMaster !== undefined &&
          CouponMaster !== null
        ) {
          const list = Array.isArray(CouponMaster)
            ? CouponMaster
            : [CouponMaster];
          // allCouponsRef.current = list;
        }
      }
      setIsLoading(false);
      setSelectedTab('add-coupon');
    } catch (error) {
      setIsLoading(false);
      setSelectedTab('add-coupon');
    }
  };

  return (
    <section className="agent-series-fare py-4">
      <AppLoading isLoading={isLoading} />
      <div className="d-flex align-items-center gap-1 fs-14 fw-600 mb-2 train-search-container">
        <AppLink linkText="Accounts" onClick={() => navigate(-1)} />
        <MdOutlineKeyboardArrowRight className="fs-5" />
        <span>Agent Series Fare</span>
      </div>
      <section className="agent-series-fare_container">
        <div className="agent-series-fare_header">
          Agent series Fare coupons
        </div>
        <div className="p-3">
          <div className="d-flex gap-2">
            <AppButton
              btnText="View Coupons"
              variant={selectedTab === 'view-coupon' ? 'primary' : 'outlined'}
              onClick={() => setSelectedTab('view-coupon')}
            />
            <AppButton
              btnText="Add Coupons"
              variant={selectedTab === 'add-coupon' ? 'primary' : 'outlined'}
              onClick={() => setSelectedTab('add-coupon')}
            />
          </div>
          <div>
            {selectedTab === 'view-coupon' && <AgentSeriesFare />}
            {selectedTab === 'add-coupon' && (
              <AddCoupon onRefreshForNewCoupons={handlegetAllCoupons} />
            )}
          </div>
        </div>
      </section>
    </section>
  );
}

export default AgentSeriesFarePage;
